import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {httpDeletePatient} from './patients.http'
import {MUTATION_KEYS} from '@/queryClient'

export const useDeletePatient = (patientId: string, options?: Omit<UseMutationOptions, 'mutationFn'>) =>
    useMutation({
        mutationKey: [MUTATION_KEYS.DELETE_PATIENT],
        mutationFn: () => httpDeletePatient({urlParams: {patientId}}),
        ...options
    })
